<template>
  <div class="ranking">
    <div class="top-row">
      <p class="tips">
        <i class="el-icon-info"></i>
        <span
          >查看成绩排行请先点击右侧“成绩结算”按钮，系统将根据该动作来统计学生成绩</span
        >
      </p>
      <el-button
        type="primary"
        size="medium"
        style="float: right"
        @click="handleScore"
        >成绩结算</el-button
      >
    </div>

    <el-table class="list" :data="list">
      <el-table-column type="index" label="排名" width="100" align="center">
        <template slot-scope="scope">
          <img
            src="@/assets/images/icons/icon_first.png"
            alt
            v-if="scope.$index + 1 == 1"
          />
          <img
            src="@/assets/images/icons/icon_second.png"
            alt
            v-if="scope.$index + 1 == 2"
          />
          <img
            src="@/assets/images/icons/icon_third.png"
            alt
            v-if="scope.$index + 1 == 3"
          />
          <span v-if="scope.$index + 1 > 3">{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="teamName" label="团队名称"> </el-table-column>
      <el-table-column
        prop="captainName"
        label="队长"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="score" label="得分" width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.score ? Number(scope.row.score.toFixed(2)) : 0 }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { teamRanking, settle } from "@/api/projectPractice/common";

export default {
  props: {
    category: String,
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 排行列表
    getList() {
      this.$loading.show();
      teamRanking(this.category, this.$route.query.id).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 成绩结算
    handleScore() {
      this.$confirm("确定要结算成绩吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          settle(this.category, this.$route.query.id).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("结算成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.ranking {
  .top-row {
    margin-bottom: 10px;
    line-height: 36px;
    overflow: hidden;
    .tips {
      float: left;
      color: #909399;
      text-align: left;
      i {
        margin-right: 5px;
      }
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>